export default __webpack_public_path__ + "static/media/tick-circle.4a86b6f0.svg";